import { useIdioma } from '../../context/IdiomaContext';

import './Privacidad.css';

function Privacidad() {
  const { t } = useIdioma();

  const datosRecopilados = t(
    'privacidad.datos.lista'
  );

  const finalidades = t(
    'privacidad.finalidad.lista'
  );

  const baseJuridica = t(
    'privacidad.baseJuridica.parrafos'
  );

  const conservacion = t(
    'privacidad.conservacion.parrafos'
  );

  return (
    <main className="pagina-legal">
      <article className="legal-contenido">
        <header className="legal-encabezado">
          <p className="legal-etiqueta">
            {t('privacidad.etiqueta')}
          </p>

          <h1>{t('privacidad.titulo')}</h1>

          <p>
            {t(
              'privacidad.ultimaActualizacion'
            )}
          </p>
        </header>

        {/* Responsable */}

        <section>
          <h2>
            {t('privacidad.responsable.titulo')}
          </h2>

          <ul>
            <li>
              <strong>
                {t(
                  'privacidad.responsable.nombre'
                )}
                :
              </strong>{' '}
              José Manuel Martín Corvillo
            </li>

            <li>
              <strong>
                {t(
                  'privacidad.responsable.nif'
                )}
                :
              </strong>{' '}
              44517403Y
            </li>

            <li>
              <strong>
                {t(
                  'privacidad.responsable.email'
                )}
                :
              </strong>{' '}

              <a href="mailto:contacto@jmmartinlabs.com">
                contacto@jmmartinlabs.com
              </a>
            </li>

            <li>
              <strong>
                {t(
                  'privacidad.responsable.domicilio'
                )}
                :
              </strong>{' '}
              C/ Ibiza 23, 6, 46024 Valencia,
              España
            </li>
          </ul>
        </section>

        {/* Datos recopilados */}

        <section>
          <h2>
            {t('privacidad.datos.titulo')}
          </h2>

          <p>
            {t('privacidad.datos.introduccion')}
          </p>

          <ul>
            {datosRecopilados.map(
              (dato, index) => (
                <li key={index}>{dato}</li>
              )
            )}
          </ul>

          <p>
            {t('privacidad.datos.aviso')}
          </p>
        </section>

        {/* Finalidad */}

        <section>
          <h2>
            {t('privacidad.finalidad.titulo')}
          </h2>

          <p>
            {t(
              'privacidad.finalidad.introduccion'
            )}
          </p>

          <ul>
            {finalidades.map(
              (finalidad, index) => (
                <li key={index}>
                  {finalidad}
                </li>
              )
            )}
          </ul>

          <p>
            {t('privacidad.finalidad.aviso')}
          </p>
        </section>

        {/* Base jurídica */}

        <section>
          <h2>
            {t(
              'privacidad.baseJuridica.titulo'
            )}
          </h2>

          {baseJuridica.map(
            (parrafo, index) => (
              <p key={index}>{parrafo}</p>
            )
          )}
        </section>

        {/* Conservación */}

        <section>
          <h2>
            {t(
              'privacidad.conservacion.titulo'
            )}
          </h2>

          {conservacion.map(
            (parrafo, index) => (
              <p key={index}>{parrafo}</p>
            )
          )}
        </section>

        {/* Proveedores */}

        <section>
          <h2>
            {t(
              'privacidad.proveedores.titulo'
            )}
          </h2>

          <p>
            {t(
              'privacidad.proveedores.noCesion'
            )}
          </p>

          <p>
            {t(
              'privacidad.proveedores.introduccion'
            )}
          </p>

          <ul>
            <li>
              <strong>
                {t(
                  'privacidad.proveedores.alojamiento'
                )}
                :
              </strong>{' '}
              Cloudflare, Inc.
            </li>

            <li>
              <strong>
                {t(
                  'privacidad.proveedores.envioCorreo'
                )}
                :
              </strong>{' '}
              Cloudflare, Inc.,{' '}
              {t(
                'privacidad.proveedores.medianteCloudflare'
              )}
            </li>

            <li>
              <strong>
                {t(
                  'privacidad.proveedores.recepcionCorreo'
                )}
                :
              </strong>{' '}
              Google Ireland Limited,{' '}
              {t(
                'privacidad.proveedores.medianteGmail'
              )}
            </li>
          </ul>

          <p>
            {t(
              'privacidad.proveedores.transferencias'
            )}
          </p>
        </section>

        {/* Derechos */}

        <section>
          <h2>
            {t('privacidad.derechos.titulo')}
          </h2>

          <p>
            {t(
              'privacidad.derechos.descripcion'
            )}{' '}

            <a href="mailto:contacto@jmmartinlabs.com">
              contacto@jmmartinlabs.com
            </a>
            .
          </p>

          <p>
            {t(
              'privacidad.derechos.solicitud'
            )}
          </p>

          <p>
            {t(
              'privacidad.derechos.reclamacionInicio'
            )}{' '}

            <a
              href="https://www.aepd.es/"
              target="_blank"
              rel="noopener noreferrer"
            >
              {t(
                'privacidad.derechos.aepd'
              )}
            </a>
            .
          </p>
        </section>

        {/* Seguridad */}

        <section>
          <h2>
            {t('privacidad.seguridad.titulo')}
          </h2>

          <p>
            {t(
              'privacidad.seguridad.descripcion'
            )}
          </p>
        </section>

        {/* Cambios */}

        <section>
          <h2>
            {t('privacidad.cambios.titulo')}
          </h2>

          <p>
            {t(
              'privacidad.cambios.descripcion'
            )}
          </p>
        </section>
      </article>
    </main>
  );
}

export default Privacidad;